module.exports = __webpack_public_path__ + "img/activity1.a2b2217c.jpg";